'use client';

import styled from 'styled-components';

export const StyledWinnerContent = styled.div`
  && > p:not(:last-child) {
    margin-bottom: var(--size-1);
  }
`;
